import {useQueryClient} from '@tanstack/react-query';
import {Box} from '@mantine/core';
import {ReloadButton} from '@flexinet/ui-components';

import {pricesKeys} from '../hooks/usePricesQuery';

/**
 * FNP-918: reload now INVALIDATES the list key rather than calling
 * `fetchRecords`.
 *
 * Under the infinite query `fetchRecords` means "fetch the NEXT page" — so
 * wiring Reload to it would have appended a page instead of refreshing, which
 * is the opposite of what the control says it does. Invalidating drops the
 * accumulated pages and refetches from the first one.
 *
 * It goes through the query client rather than `usePrices().reload` so this
 * button does not instantiate a second copy of the whole list hook — which is
 * what the previous version did, firing its own query just to reach one
 * callback.
 */
export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    return (
        <Box mx='s'>
            <ReloadButton
                onClick={() => queryClient.invalidateQueries({
                    queryKey: pricesKeys.lists(),
                })}
            />
        </Box>
    );
};
